<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconHeadset_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        d="M8 2a7 7 0 0 1 7 7v2.45a2.45 2.45 0 0 1-2.45 2.45c-1.353 0-1.45-1.097-1.45-2.45v-1.4c0-1.353.097-2.45 1.45-2.45.324 0 .633.063.916.177a5.602 5.602 0 0 0-10.932 0c.283-.114.592-.177.916-.177 1.353 0 1.45 1.097 1.45 2.45v1.4c0 1.353-.097 2.45-1.45 2.45A2.45 2.45 0 0 1 1 11.45V9a7 7 0 0 1 7-7"
    />
</svg>
